// This file is from the Atlassian Design System (https://atlassian.design/components/blanket/examples)
import { type ReactNode } from "react";
import styled from "styled-components";
// TODO: Import Blanket.module.css when we fix preload errors on production.
// See: https://rome2rio.sentry.io/issues/6150562411/events/c4528d0672544b0e8a3a439b7cf29d01/?project=4505632747487232&referrer=previous-event

type BlanketProps = {
  onBlanketClicked: (event: React.MouseEvent<HTMLDivElement>) => void;
  children?: ReactNode;
};

/**
 * __Blanket__
 *
 *  A blanket covers the underlying UI for a layered component, such as a modal or a draw.
 *
 */
export function Blanket({ onBlanketClicked, children }: BlanketProps) {
  return (
    <BlanketContainer role="presentation" onClick={onBlanketClicked}>
      {children}
    </BlanketContainer>
  );
}

const BlanketContainer = styled.div`
  z-index: var(--z-index-blanket);
  position: fixed;
  inset: 0;
  background-color: var(--color-blanket-bg);
  overflow-y: auto;
  pointer-events: initial;
  height: 100vh;
  width: 100vw;
`;
